export default __webpack_public_path__ + "static/screenshot-A-34f8d64fd748ea6a993f57440dd75729.png";